import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=2aca0d78&scoped=true&"
import script from "./Companies.vue?vue&type=script&lang=js&"
export * from "./Companies.vue?vue&type=script&lang=js&"
import style0 from "./Companies.vue?vue&type=style&index=0&id=2aca0d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca0d78",
  null
  
)

export default component.exports